import { HttpApi } from './api';
import { HttpRequestFactory } from './request.factory';

export function HttpApiFactory(): HttpApi {
  return new HttpApi(HttpRequestFactory, typeof window === 'undefined' ? '' : window.location.origin);
}
